import styled from '@emotion/styled';
import LogoFull from '../Root/LogoFull';
import { Content } from '@backstage/core-components';
import { Link, Button } from '@material-ui/core';

export const StyledContent = styled(Content)`
  background: url('./dlr_login_bg.jpg');
  background-size: cover;
  display: grid;
  grid-template-rows: 1fr auto;
  align-items: center;
  justify-items: center;
  min-height: 100vh;
  padding: 48px 24px;
  row-gap: 32px;
  width: 100%;
`;

export const StyledLogoFull = styled(LogoFull)`
  width: 256px;
  height: 58px;
`;

export const StyledLink = styled(Link)`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  font-family: 'Open Sans', sans-serif;
  margin: 0;
  letter-spacing: 0.4px;
  cursor: pointer;
  text-decoration: underline !important;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  border-radius: 0 !important;
  cursor: pointer;
`;

export const StyledMain = styled('div')`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const FullScreenContainer = styled('div')`
  width: 100%;
  min-height: 100vh;
`;

export const Footer = styled('footer')`
  width: 100%;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`;

export const FooterText = styled('p')`
  margin: 0;
  font-size: 12px;
  text-align: center;
`;

export const FooterLinks = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 12px;
`;

export const FooterLink = styled(Link)`
  font-size: 12px;
  color: #ffffff !important;
  text-decoration: underline !important;
  cursor: pointer;
`;
